export const state = () => ({
  publishedLineDetail: {},//发布项信息
  publishType: '',//发布类型
  publishForm: {},//挂盘可填写基本信息
  domain: '',//领域
  baseinfoHead: {},//挂盘右侧基本信息
  stepTableRef: null,//设置页面表格ref，跨组件使用
  psTableOption: null,//暂存表格信息，跨组件使用
  rfqAvabTableOption: null,//暂存表格信息，跨组件使用
  editCacheData: {},//购销在编辑的表格行
  rfqAvabStepData: [],//询供实时表格数据
  allTags: [],//用于提交删选的tags
  tableRenderingFinish:false//表格数据赋值完毕
});
export const mutations = {
  set_published_line_detail(state, v) {
    state.publishedLineDetail = v;
  },
  set_type(state, v) {
    state.publishType = v;
  },
  setForm(state, v) {
    state.publishForm = v;
  },
  set_domain(state, v) {
    state.domain = v;
  },
  set_baseInfo_head(state, v) {
    state.baseinfoHead = v;
  },
  set_stepTableRef(state, v) {
    state.stepTableRef = v;
  },
  set_psTableOption(state, v) {
    state.psTableOption = v;
  },
  set_rfqAvabTableOption(state, v) {
    state.rfqAvabTableOption = v;
  },
  set_rfqAvabStepData(state, v) {
    state.rfqAvabStepData = v;
  },
  set_editCacheData(state, { key, value, fresh }) {
    if (fresh) {
      state.editCacheData = {};
    } else {
      state.editCacheData[key] = value;
    }
  },
  set_all_tags(state, v) {
    state.allTags = v;
  },
  set_table_rendering_finish(state, v) {
    state.tableRenderingFinish = v;
  },

};
export default {
  state,
  mutations,
}
